import BaseDialog from '../components/BaseDialog' // Adjust path based on dialogs folder
import { DialogContentText, Button, DialogActions } from '@mui/material'

/**
 * A generic Alert Dialog component using BaseDialog.
 * It displays a title, a message, and optional action buttons.
 *
 * @param {object} props - The component props.
 * @param {boolean} props.open - Controls whether the dialog is open or closed.
 * @param {string} props.title - The title of the alert dialog.
 * @param {string} props.message - The message content of the alert dialog.
 * @param {function} props.onClose - Callback function triggered when the dialog is requested to close (e.g., by clicking the close button).
 * @param {Array<object>} [props.actions] - Optional array of action buttons. Each object should have `text`, `handler`, and `props` (for MUI Button props).
 */
const AlertDialog = ({ open, title, message, onClose, actions }) => {
    return (
        <BaseDialog open={open} onClose={onClose} title={title}>
            <DialogContentText>{message}</DialogContentText>
            {actions && actions.length > 0 && (
                <DialogActions>
                    {actions.map((action, index) => (
                        <Button key={index} onClick={action.handler} {...action.props}>
                            {action.text}
                        </Button>
                    ))}
                </DialogActions>
            )}
        </BaseDialog>
    )
}

export default AlertDialog
